import { render, staticRenderFns } from "./editCustom.vue?vue&type=template&id=ef9a8b80"
import script from "./editCustom.vue?vue&type=script&lang=js"
export * from "./editCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports